module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-label-box d-inline-block"
  }, [(_vm.label && !_vm.useLabelInline) ? _c('span', {
    staticClass: "label text-muted"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('b-dropdown', {
    ref: "dropdown",
    staticClass: "dropdown",
    attrs: {
      "text": _vm.selectedItemText,
      "size": _vm.size,
      "right": _vm.right
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: item.text,
      on: {
        "contextmenu": function($event) {
          _vm.handleClick($event, index, true)
        }
      }
    }, [_c('b-dropdown-item', {
      attrs: {
        "active": _vm.selectedCurrentItemIndex === index
      },
      on: {
        "click": function($event) {
          _vm.handleClick($event, index, false)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t")])], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24139962"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoDropdown.vue
// module id = 607
// module chunks = 0